// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import toast from "react-hot-toast";
// import Loader from "../common/Loader";
// import { FaTimes } from "react-icons/fa";
// import RichTextEditor from "../common/RichTextEditor";

// const EditSubSubserviceModal = ({
//   isOpen,
//   onClose,
//   subsubservice,
//   onSubSubserviceUpdated,
//   allSubservices,
//   allServices,
// }) => {
//   const [selectedServiceId, setSelectedServiceId] = useState("");
//   const [subservice, setSubservice] = useState("");
//   const [subsubserviceName, setSubsubserviceName] = useState("");
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [images, setImages] = useState([]);
//   const [overview, setOverview] = useState([]);
//   const [authorName, setAuthorName] = useState("");
//   const [authorDescription, setAuthorDescription] = useState("");
//   const [logo, setLogo] = useState("");
//   const [loading, setLoading] = useState(false);

//   // ✅ Filter subservices by selected service
//   const filteredSubservices = selectedServiceId
//     ? allSubservices.filter((s) => s?.service?._id === selectedServiceId || s?.service === selectedServiceId)
//     : allSubservices;

//  useEffect(() => {
//   if (!subsubservice) return;

//   const parentServiceId =
//     subsubservice?.service?._id ||
//     subsubservice?.service ||
//     subsubservice?.subservice?.service?._id ||
//     subsubservice?.subservice?.service ||
//     "";
//   setSelectedServiceId(parentServiceId);

//   setSubservice(subsubservice?.subservice?._id || "");
//   setSubsubserviceName(subsubservice?.subsubserviceName || "");
//   setTitle(subsubservice?.title || "");
//   setDescription(subsubservice?.description?.join("\n") || "");
//   setImages(subsubservice?.images || []);
//   setOverview(
//     subsubservice?.overview?.map((o) => ({
//       name: o.name || "",
//       title: o.title || "",
//       description: o.description?.join("\n") || "",
//       points: o.points?.map((p) => ({ heading: p.heading || "", description: p.description || "" })) || [{ heading: "", description: "" }],
//       images: o.images || [],
//     })) || [{ name: "", title: "", description: "", points: [{ heading: "", description: "" }], images: [] }]
//   );
//   setAuthorName(subsubservice?.authorName || "");
//   setAuthorDescription(subsubservice?.authorDescription || "");
//   setLogo(subsubservice?.logo || "");
// }, [subsubservice, allSubservices]);   

//   const uploadToCloudinary = async (file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);
//     const res = await axios.post(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`, formData);
//     return res.data.secure_url;
//   };

//   const handleImageUpload = async (e) => {
//     const files = e.target.files;
//     if (!files.length) return;
//     setLoading(true);
//     try {
//       const urls = await Promise.all(Array.from(files).map(uploadToCloudinary));
//       setImages([...images, ...urls]);
//       toast.success("Images uploaded successfully");
//     } catch { toast.error("Image upload failed"); }
//     finally { setLoading(false); }
//   };

//   const handleLogoUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setLoading(true);
//     try {
//       const url = await uploadToCloudinary(file);
//       setLogo(url);
//       toast.success("Logo uploaded successfully");
//     } catch { toast.error("Logo upload failed"); }
//     finally { setLoading(false); }
//   };

//   const handleOverviewImageUpload = async (index, e) => {
//     const files = e.target.files;
//     if (!files.length) return;
//     setLoading(true);
//     try {
//       const urls = await Promise.all(Array.from(files).map(uploadToCloudinary));
//       const temp = [...overview];
//       temp[index].images = [...temp[index].images, ...urls];
//       setOverview(temp);
//       toast.success("Overview images uploaded");
//     } catch { toast.error("Overview image upload failed"); }
//     finally { setLoading(false); }
//   };

//   const addOverview = () => setOverview([...overview, { name: "", title: "", description: "", points: [{ heading: "", description: "" }], images: [] }]);
//   const removeOverview = (i) => setOverview(overview.filter((_, idx) => idx !== i));
//   const updateOverview = (i, field, value) => { const temp = [...overview]; temp[i][field] = value; setOverview(temp); };
//   const addPoint = (i) => { const temp = [...overview]; temp[i].points.push({ heading: "", description: "" }); setOverview(temp); };
//   const removePoint = (i, pi) => { const temp = [...overview]; temp[i].points = temp[i].points.filter((_, idx) => idx !== pi); setOverview(temp); };
//   const updatePoint = (i, pi, field, value) => { const temp = [...overview]; temp[i].points[pi][field] = value; setOverview(temp); };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!subservice || !subsubserviceName) return toast.error("Please fill required fields");

//     setLoading(true);
//     try {
//       const payload = {
//         service: selectedServiceId,   // ✅ send service field
//         subservice,
//         subsubserviceName: subsubserviceName.trim(),
//         title: title.trim() || undefined,
//         description: description.split("\n").map((d) => d.trim()).filter(Boolean),
//         images,
//         authorName: authorName.trim() || undefined,
//         authorDescription: authorDescription.trim() || undefined,
//         logo: logo || undefined,
//         overview: overview.map((o) => ({
//           name: o.name,
//           title: o.title || undefined,
//           description: o.description ? o.description.split("\n").map((d) => d.trim()).filter(Boolean) : undefined,
//           points: o.points.filter((p) => p.heading && p.description),
//           images: o.images.length ? o.images : undefined,
//         })),
//       };

//       payload.overview = payload.overview.map((item) => {
//         const clean = {};
//         Object.keys(item).forEach((k) => {
//           if (item[k] !== undefined && item[k] !== "" && !(Array.isArray(item[k]) && !item[k].length)) clean[k] = item[k];
//         });
//         return clean;
//       });

//       const res = await axios.put(`${process.env.REACT_APP_API_URL}/subsubservices/edit-subsubservice/${subsubservice._id}`, payload);
//       onSubSubserviceUpdated(res.data.data);
//       toast.success("Sub-SubService updated successfully");
//       onClose();
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to update Sub-SubService");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//       <div className="bg-white rounded-lg w-full max-w-5xl max-h-[90vh] overflow-y-auto p-6">
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-xl font-bold">Edit Sub-SubService</h2>
//           <button onClick={onClose} className="text-gray-600 hover:text-gray-800"><FaTimes /></button>
//         </div>

//         <form onSubmit={handleSubmit} className="space-y-6">

//           {/* ✅ Parent Service */}
//           <div>
//             <label className="block mb-2 font-medium">Parent Service *</label>
//             <select
//               value={selectedServiceId}
//               onChange={(e) => { setSelectedServiceId(e.target.value); setSubservice(""); }}
//               className="w-full border px-3 py-2 rounded"
//             >
//               <option value="">Select Service</option>
//               {allServices.map((srv) => (
//                 <option key={srv._id} value={srv._id}>{srv.serviceName || srv.name}</option>
//               ))}
//             </select>
//           </div>

//           {/* ✅ Parent Subservice — filtered by service */}
//           <div>
//             <label className="block mb-2 font-medium">Parent Subservice *</label>
//             <select
//               value={subservice}
//               onChange={(e) => setSubservice(e.target.value)}
//               disabled={!selectedServiceId}
//               className="w-full border px-3 py-2 rounded disabled:bg-gray-100 disabled:cursor-not-allowed"
//             >
//               <option value="">Select Subservice</option>
//               {filteredSubservices.map((s) => (
//                 <option key={s._id} value={s._id}>{s.subserviceName}</option>
//               ))}
//             </select>
//           </div>

//           {/* SubSubservice Name */}
//           <div>
//             <label className="block mb-2 font-medium">SubSubService Name *</label>
//             <input type="text" value={subsubserviceName} onChange={(e) => setSubsubserviceName(e.target.value)} className="w-full border px-3 py-2 rounded" />
//           </div>

//           {/* Title */}
//           <div>
//             <label className="block mb-2 font-medium">Title</label>
//             <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="w-full border px-3 py-2 rounded" />
//           </div>

//           {/* Description */}
//           <div className="mb-4">
//             <label className="block mb-2 font-medium">Description</label>
//             <RichTextEditor value={description} onChange={(val) => setDescription(val)} placeholder="Enter description..." />
//           </div>

//           {/* Images */}
//           <div>
//             <label className="block mb-2 font-medium">Images (500×400 size)</label>
//             <input type="file" multiple accept="image/*" onChange={handleImageUpload} />
//             <div className="flex flex-wrap gap-2 mt-2">
//               {images.map((img, i) => (
//                 <div key={i} className="relative">
//                   <img src={img} alt="subsubservice" className="w-20 h-20 object-cover rounded border" />
//                   <button type="button" onClick={() => setImages(images.filter((_, idx) => idx !== i))} className="absolute -top-1 -right-1 bg-red-500 text-white w-4 h-4 text-xs rounded-full">×</button>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Overview Sections */}
//           <div>
//             <h3 className="font-semibold mb-2">Overview Sections</h3>
//             {overview.map((item, i) => (
//               <div key={i} className="border p-3 rounded mb-4 bg-gray-50">
//                 <div className="flex justify-between items-center mb-2">
//                   <h4 className="font-medium">Overview {i + 1}</h4>
//                   {overview.length > 1 && <button type="button" onClick={() => removeOverview(i)} className="text-red-500">Remove</button>}
//                 </div>
//                 <input type="text" placeholder="Tab Name" value={item.name} onChange={(e) => updateOverview(i, "name", e.target.value)} className="w-full border px-2 py-1 mb-2 rounded" />
//                 <input type="text" placeholder="Header" value={item.title} onChange={(e) => updateOverview(i, "title", e.target.value)} className="w-full border px-2 py-1 mb-2 rounded" />
//                 <div className="mb-2">
//                   <label className="block mb-1 text-sm font-medium">Description</label>
//                   <RichTextEditor value={item.description} onChange={(val) => updateOverview(i, "description", val)} placeholder="Enter overview description..." />
//                 </div>
//                 <div className="my-4">
//                   <label className="block mb-1 text-sm font-medium">Points</label>
//                   {item.points.map((p, pi) => (
//                     <div key={pi} className="flex flex-col gap-2 mb-2">
//                       <input type="text" placeholder="Heading" value={p.heading} onChange={(e) => updatePoint(i, pi, "heading", e.target.value)} className="w-full border px-2 py-1 rounded" />
//                       <RichTextEditor value={p.description} onChange={(val) => updatePoint(i, pi, "description", val)} placeholder="Enter point description..." />
//                       {item.points.length > 1 && <button type="button" onClick={() => removePoint(i, pi)} className="text-red-500">×</button>}
//                     </div>
//                   ))}
//                 </div>
//                 <button type="button" onClick={() => addPoint(i)} className="bg-green-500 text-white px-2 py-1 rounded text-sm">+ Add Point</button>
//                 <div className="mt-2">
//                   <input type="file" multiple accept="image/*" onChange={(e) => handleOverviewImageUpload(i, e)} />
//                   <div className="flex flex-wrap gap-2 mt-2">
//                     {item.images.map((img, j) => (
//                       <div key={j} className="relative">
//                         <img src={img} alt="overview" className="w-16 h-16 object-cover rounded border" />
//                         <button type="button" onClick={() => { const tmp = [...overview]; tmp[i].images = tmp[i].images.filter((_, idx) => idx !== j); setOverview(tmp); }} className="absolute -top-1 -right-1 bg-red-500 text-white w-4 h-4 text-xs rounded-full">×</button>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             ))}
//             <button type="button" onClick={addOverview} className="bg-blue-500 text-white px-3 py-1 rounded">+ Add Overview</button>
//           </div>

//           {/* Author & Logo */}
//           <div className="flex flex-col gap-2">
//             <input type="text" placeholder="Author Name" value={authorName} onChange={(e) => setAuthorName(e.target.value)} className="w-full border px-3 py-2 rounded" />
//             <div>
//               <label className="block mb-2 font-medium">Author Description</label>
//               <RichTextEditor value={authorDescription} onChange={setAuthorDescription} placeholder="Enter author description..." />
//             </div>
//             <label>Logo (160×160 size)</label>
//             <input type="file" accept="image/*" onChange={handleLogoUpload} />
//             {logo && <img src={logo} alt="logo" className="w-20 h-20 mt-2 object-cover rounded border" />}
//           </div>

//           <div className="flex justify-end gap-4 pt-3 border-t">
//             <button type="button" onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
//             <button type="submit" disabled={loading} className="bg-orange-500 text-white px-4 py-2 rounded">{loading ? <Loader /> : "Update Sub-SubService"}</button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditSubSubserviceModal;


import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Loader from "../common/Loader";
import { FaTimes } from "react-icons/fa";
import RichTextEditor from "../common/RichTextEditor";

const EditSubSubserviceModal = ({
  isOpen,
  onClose,
  subsubservice,
  onSubSubserviceUpdated,
  allSubservices,
  allServices,
}) => {
  const [selectedServiceId, setSelectedServiceId] = useState("");
  const [subservice, setSubservice] = useState("");
  const [subsubserviceName, setSubsubserviceName] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [order, setOrder] = useState(0); // ✅ NEW
  const [overview, setOverview] = useState([]);
  const [authorName, setAuthorName] = useState("");
  const [authorDescription, setAuthorDescription] = useState("");
  const [logo, setLogo] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ NEW: SEO Fields
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");

  // ✅ Filter subservices by selected service
  const filteredSubservices = selectedServiceId
    ? allSubservices.filter((s) => s?.service?._id === selectedServiceId || s?.service === selectedServiceId)
    : allSubservices;

 useEffect(() => {
  if (!subsubservice) return;

  const parentServiceId =
    subsubservice?.service?._id ||
    subsubservice?.service ||
    subsubservice?.subservice?.service?._id ||
    subsubservice?.subservice?.service ||
    "";
  setSelectedServiceId(parentServiceId);

  setSubservice(subsubservice?.subservice?._id || "");
  setSubsubserviceName(subsubservice?.subsubserviceName || "");
  setTitle(subsubservice?.title || "");
  setDescription(subsubservice?.description?.join("\n") || "");
  setImages(subsubservice?.images || []);
  setOrder(subsubservice?.order || 0); // ✅ NEW
  setOverview(
    subsubservice?.overview?.map((o) => ({
      name: o.name || "",
      title: o.title || "",
      description: o.description?.join("\n") || "",
      points: o.points?.map((p) => ({ heading: p.heading || "", description: p.description || "" })) || [{ heading: "", description: "" }],
      images: o.images || [],
    })) || [{ name: "", title: "", description: "", points: [{ heading: "", description: "" }], images: [] }]
  );
  setAuthorName(subsubservice?.authorName || "");
  setAuthorDescription(subsubservice?.authorDescription || "");
  setLogo(subsubservice?.logo || "");

  // ✅ NEW: SEO Fields
  setMetaTitle(subsubservice?.metaTitle || "");
  setMetaDescription(subsubservice?.metaDescription || "");
  setMetaKeywords(subsubservice?.metaKeywords || "");
  setCanonicalUrl(subsubservice?.canonicalUrl || "");
}, [subsubservice, allSubservices]);   

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);
    const res = await axios.post(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`, formData);
    return res.data.secure_url;
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (!files.length) return;
    setLoading(true);
    try {
      const urls = await Promise.all(Array.from(files).map(uploadToCloudinary));
      setImages([...images, ...urls]);
      toast.success("Images uploaded successfully");
    } catch { toast.error("Image upload failed"); }
    finally { setLoading(false); }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    try {
      const url = await uploadToCloudinary(file);
      setLogo(url);
      toast.success("Logo uploaded successfully");
    } catch { toast.error("Logo upload failed"); }
    finally { setLoading(false); }
  };

  const handleOverviewImageUpload = async (index, e) => {
    const files = e.target.files;
    if (!files.length) return;
    setLoading(true);
    try {
      const urls = await Promise.all(Array.from(files).map(uploadToCloudinary));
      const temp = [...overview];
      temp[index].images = [...temp[index].images, ...urls];
      setOverview(temp);
      toast.success("Overview images uploaded");
    } catch { toast.error("Overview image upload failed"); }
    finally { setLoading(false); }
  };

  const addOverview = () => setOverview([...overview, { name: "", title: "", description: "", points: [{ heading: "", description: "" }], images: [] }]);
  const removeOverview = (i) => setOverview(overview.filter((_, idx) => idx !== i));
  const updateOverview = (i, field, value) => { const temp = [...overview]; temp[i][field] = value; setOverview(temp); };
  const addPoint = (i) => { const temp = [...overview]; temp[i].points.push({ heading: "", description: "" }); setOverview(temp); };
  const removePoint = (i, pi) => { const temp = [...overview]; temp[i].points = temp[i].points.filter((_, idx) => idx !== pi); setOverview(temp); };
  const updatePoint = (i, pi, field, value) => { const temp = [...overview]; temp[i].points[pi][field] = value; setOverview(temp); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!subservice || !subsubserviceName) return toast.error("Please fill required fields");

    setLoading(true);
    try {
      const payload = {
        service: selectedServiceId,   // ✅ send service field
        subservice,
        subsubserviceName: subsubserviceName.trim(),
        title: title.trim() || undefined,
        description: description.split("\n").map((d) => d.trim()).filter(Boolean),
        images,
        order: order || 0, // ✅ NEW
        authorName: authorName.trim() || undefined,
        authorDescription: authorDescription.trim() || undefined,
        logo: logo || undefined,
        overview: overview.map((o) => ({
          name: o.name,
          title: o.title || undefined,
          description: o.description ? o.description.split("\n").map((d) => d.trim()).filter(Boolean) : undefined,
          points: o.points.filter((p) => p.heading && p.description),
          images: o.images.length ? o.images : undefined,
        })),
        // ✅ NEW: SEO Fields
        metaTitle: metaTitle.trim() || `${subsubserviceName} | BBSR Services`,
        metaDescription: metaDescription.trim() || description?.split("\n").filter(d => d.trim())[0]?.substring(0, 160) || '',
        metaKeywords: metaKeywords.trim() || `${subsubserviceName}, BBSR Services, business solutions`,
        canonicalUrl: canonicalUrl.trim() || `https://www.bbsrservices.co.in/sub-subservice/${subsubserviceName.toLowerCase().replace(/\s+/g, '-')}`,
      };

      payload.overview = payload.overview.map((item) => {
        const clean = {};
        Object.keys(item).forEach((k) => {
          if (item[k] !== undefined && item[k] !== "" && !(Array.isArray(item[k]) && !item[k].length)) clean[k] = item[k];
        });
        return clean;
      });

      const res = await axios.put(`${process.env.REACT_APP_API_URL}/subsubservices/edit-subsubservice/${subsubservice._id}`, payload);
      onSubSubserviceUpdated(res.data.data);
      toast.success("Sub-SubService updated successfully");
      onClose();
    } catch (err) {
      console.error(err);
      toast.error("Failed to update Sub-SubService");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg w-full max-w-5xl max-h-[90vh] overflow-y-auto p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Edit Sub-SubService</h2>
          <button onClick={onClose} className="text-gray-600 hover:text-gray-800"><FaTimes /></button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">

          {/* ✅ Parent Service */}
          <div>
            <label className="block mb-2 font-medium">Parent Service *</label>
            <select
              value={selectedServiceId}
              onChange={(e) => { setSelectedServiceId(e.target.value); setSubservice(""); }}
              className="w-full border px-3 py-2 rounded"
            >
              <option value="">Select Service</option>
              {allServices.map((srv) => (
                <option key={srv._id} value={srv._id}>{srv.serviceName || srv.name}</option>
              ))}
            </select>
          </div>

          {/* ✅ Parent Subservice — filtered by service */}
          <div>
            <label className="block mb-2 font-medium">Parent Subservice *</label>
            <select
              value={subservice}
              onChange={(e) => setSubservice(e.target.value)}
              disabled={!selectedServiceId}
              className="w-full border px-3 py-2 rounded disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="">Select Subservice</option>
              {filteredSubservices.map((s) => (
                <option key={s._id} value={s._id}>{s.subserviceName}</option>
              ))}
            </select>
          </div>

          {/* SubSubservice Name */}
          <div>
            <label className="block mb-2 font-medium">SubSubService Name *</label>
            <input type="text" value={subsubserviceName} onChange={(e) => setSubsubserviceName(e.target.value)} className="w-full border px-3 py-2 rounded" />
          </div>

          {/* Title */}
          <div>
            <label className="block mb-2 font-medium">Title</label>
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="w-full border px-3 py-2 rounded" />
          </div>

          {/* ✅ NEW: Order */}
          <div>
            <label className="block mb-2 font-medium">Display Order</label>
            <input
              type="number"
              placeholder="Enter order number (0, 1, 2, ...)"
              value={order}
              onChange={(e) => setOrder(parseInt(e.target.value) || 0)}
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <p className="text-xs text-gray-500 mt-1">Lower numbers appear first</p>
          </div>

          {/* Description */}
          <div className="mb-4">
            <label className="block mb-2 font-medium">Description</label>
            <RichTextEditor value={description} onChange={(val) => setDescription(val)} placeholder="Enter description..." />
          </div>

          {/* Images */}
          <div>
            <label className="block mb-2 font-medium">Images (500×400 size)</label>
            <input type="file" multiple accept="image/*" onChange={handleImageUpload} />
            <div className="flex flex-wrap gap-2 mt-2">
              {images.map((img, i) => (
                <div key={i} className="relative">
                  <img src={img} alt="subsubservice" className="w-20 h-20 object-cover rounded border" />
                  <button type="button" onClick={() => setImages(images.filter((_, idx) => idx !== i))} className="absolute -top-1 -right-1 bg-red-500 text-white w-4 h-4 text-xs rounded-full">×</button>
                </div>
              ))}
            </div>
          </div>

          {/* Overview Sections */}
          <div>
            <h3 className="font-semibold mb-2">Overview Sections</h3>
            {overview.map((item, i) => (
              <div key={i} className="border p-3 rounded mb-4 bg-gray-50">
                <div className="flex justify-between items-center mb-2">
                  <h4 className="font-medium">Overview {i + 1}</h4>
                  {overview.length > 1 && <button type="button" onClick={() => removeOverview(i)} className="text-red-500">Remove</button>}
                </div>
                <input type="text" placeholder="Tab Name" value={item.name} onChange={(e) => updateOverview(i, "name", e.target.value)} className="w-full border px-2 py-1 mb-2 rounded" />
                <input type="text" placeholder="Header" value={item.title} onChange={(e) => updateOverview(i, "title", e.target.value)} className="w-full border px-2 py-1 mb-2 rounded" />
                <div className="mb-2">
                  <label className="block mb-1 text-sm font-medium">Description</label>
                  <RichTextEditor value={item.description} onChange={(val) => updateOverview(i, "description", val)} placeholder="Enter overview description..." />
                </div>
                <div className="my-4">
                  <label className="block mb-1 text-sm font-medium">Points</label>
                  {item.points.map((p, pi) => (
                    <div key={pi} className="flex flex-col gap-2 mb-2">
                      <input type="text" placeholder="Heading" value={p.heading} onChange={(e) => updatePoint(i, pi, "heading", e.target.value)} className="w-full border px-2 py-1 rounded" />
                      <RichTextEditor value={p.description} onChange={(val) => updatePoint(i, pi, "description", val)} placeholder="Enter point description..." />
                      {item.points.length > 1 && <button type="button" onClick={() => removePoint(i, pi)} className="text-red-500">×</button>}
                    </div>
                  ))}
                </div>
                <button type="button" onClick={() => addPoint(i)} className="bg-green-500 text-white px-2 py-1 rounded text-sm">+ Add Point</button>
                <div className="mt-2">
                  <input type="file" multiple accept="image/*" onChange={(e) => handleOverviewImageUpload(i, e)} />
                  <div className="flex flex-wrap gap-2 mt-2">
                    {item.images.map((img, j) => (
                      <div key={j} className="relative">
                        <img src={img} alt="overview" className="w-16 h-16 object-cover rounded border" />
                        <button type="button" onClick={() => { const tmp = [...overview]; tmp[i].images = tmp[i].images.filter((_, idx) => idx !== j); setOverview(tmp); }} className="absolute -top-1 -right-1 bg-red-500 text-white w-4 h-4 text-xs rounded-full">×</button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
            <button type="button" onClick={addOverview} className="bg-blue-500 text-white px-3 py-1 rounded">+ Add Overview</button>
          </div>

          {/* Author & Logo */}
          <div className="flex flex-col gap-2">
            <input type="text" placeholder="Author Name" value={authorName} onChange={(e) => setAuthorName(e.target.value)} className="w-full border px-3 py-2 rounded" />
            <div>
              <label className="block mb-2 font-medium">Author Description</label>
              <RichTextEditor value={authorDescription} onChange={setAuthorDescription} placeholder="Enter author description..." />
            </div>
            <label>Logo (160×160 size)</label>
            <input type="file" accept="image/*" onChange={handleLogoUpload} />
            {logo && <img src={logo} alt="logo" className="w-20 h-20 mt-2 object-cover rounded border" />}
          </div>

          {/* ✅ NEW: SEO Section */}
          <div className="border-t pt-4 mt-4">
            <h3 className="text-lg font-semibold text-blue-600 mb-3">SEO Settings</h3>
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Meta Title</label>
                <input
                  type="text"
                  placeholder="Meta Title (SEO)"
                  value={metaTitle}
                  onChange={(e) => setMetaTitle(e.target.value)}
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500">{metaTitle?.length || 0}/60 characters</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Meta Description</label>
                <textarea
                  placeholder="Meta Description (SEO)"
                  value={metaDescription}
                  onChange={(e) => setMetaDescription(e.target.value)}
                  rows="3"
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500">{metaDescription?.length || 0}/160 characters</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Meta Keywords</label>
                <input
                  type="text"
                  placeholder="Meta Keywords (SEO)"
                  value={metaKeywords}
                  onChange={(e) => setMetaKeywords(e.target.value)}
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500">Separate keywords with commas</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Canonical URL</label>
                <input
                  type="url"
                  placeholder="Canonical URL"
                  value={canonicalUrl}
                  onChange={(e) => setCanonicalUrl(e.target.value)}
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-4 pt-3 border-t">
            <button type="button" onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
            <button type="submit" disabled={loading} className="bg-orange-500 text-white px-4 py-2 rounded">{loading ? <Loader /> : "Update Sub-SubService"}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSubSubserviceModal;